import React, { Component } from "react";
import { Loader, utils, field } from "@mc/mc-legacy";
import { connect } from "react-redux";
import * as fieldActions from "../../actions/fieldActions";
import PropTypes from "prop-types";
/**
 * field pro filtr čipování Ma
 */

class ConfigurationField extends Component {
  static propTypes = {
    empty: PropTypes.bool,
  };
  static defaultProps = {
    empty: true,
  };

  componentDidMount() {
    this.fetchData(true);
  }

  UNSAFE_componentWillReceiveProps() {
    this.fetchData();
  }

  fetchData = (force = false) => {
    this.props.dispatch(fieldActions.fetchSignConfigurationsList(force));
  };

  render() {
    const { store, empty, ...componentProps } = this.props;

    if (store.fetching) {
      return <Loader />;
    }

    return (
      <field.Autocomplete
        {...componentProps}
        useIdAsValue
        getItemName={(item) => (item ? item.name : "")}
        items={store.rows.sort((a, b) => a.name.localeCompare(b.name))}
      />
    );
  }
}

export default connect((state) => {
  return {
    store: utils.storeFromArea(state, fieldActions.CONFIGURATIONS_LIST),
  };
})(ConfigurationField);
